import { router } from "@inertiajs/vue3";
import { onBeforeUnmount, onMounted } from "vue";
import { toast } from "vue-sonner";

import { subscribeAnnouncements } from "@/lib/channels/announcements";
import { subscribeUserNotifications } from "@/lib/channels/notifications";
import type { Announcement, RealtimeNotification } from "@/types";

export function useAnnouncementToasts() {
  let unsubscribe: (() => void) | undefined;

  onMounted(() => {
    unsubscribe = subscribeAnnouncements((msg: Announcement) => {
      const { title, body, severity } = msg;

      switch (severity) {
        case "success":
          toast.success(title, { description: body });
          break;
        case "warning":
          toast.warning(title, { description: body });
          break;
        case "error":
          toast.error(title, { description: body });
          break;
        default:
          toast(title, { description: body });
      }
    });
  });

  onBeforeUnmount(() => {
    unsubscribe?.();
  });
}

export function useUserNotificationToasts() {
  let unsubscribe: (() => void) | undefined;

  onMounted(() => {
    unsubscribe = subscribeUserNotifications((msg: RealtimeNotification) => {
      if (msg.type !== "noticed.notification") return;

      const { title, body, url } = msg.notification;
      toast(title, {
        description: body ?? undefined,
        action: url
          ? {
              label: "Ver",
              onClick: () => {
                router.visit(url);
              },
            }
          : undefined,
      });

    });
  });

  onBeforeUnmount(() => {
    unsubscribe?.();
  });
}
